<template lang="pug">
  .print-preview-wrapper
    .print-preview-label Pré-visualização: {{ layoutLabel }}
    .print-receipt(:class="'layout-' + layout")
        .receipt-center.receipt-title {{ $root.estabelecimentoSelecionado && $root.estabelecimentoSelecionado.cardapio_digital ? 'CARDAPIO DIGITAL' : 'BIGOU DELIVERY' }}
        .receipt-row(v-if="!isSimplificado")
          span.receipt-label FORNECEDOR:&nbsp;
          span {{ $root.estabelecimentoSelecionado ? $root.estabelecimentoSelecionado.nome : 'LOJA DE TESTE' }}
        .receipt-row(v-if="!isSimplificado")
          span.receipt-label PEDIDO:&nbsp;
          span 1042
        .receipt-row(v-else)
          span.receipt-bold PEDIDO:&nbsp;
          span 1042
        .receipt-row(v-if="!isSimplificado")
          span.receipt-label DATA:&nbsp;
          span {{ $dayjs().format('DD/MM/YYYY HH:mm') }}
        .receipt-row(v-if="!isSimplificado")
          span.receipt-label PREVISÃO DE ENTREGA:&nbsp;
          span {{ $dayjs().add(30, 'minutes').format('DD/MM/YYYY HH:mm') }}
        template(v-if="!isSimplificado")
          .receipt-divider DADOS DA ENTREGA
          .receipt-row
            span.receipt-label CLIENTE:&nbsp;
            span JOAO DA SILVA
          .receipt-row
            span.receipt-label TELEFONE:&nbsp;
            span (31) 99999-1234
          .receipt-row
            span.receipt-label ENDEREÇO:&nbsp;
            span RUA DAS FLORES, 123 - CENTRO
        template(v-else)
          .receipt-row
            span.receipt-label CLIENTE:&nbsp;
            span JOAO DA SILVA
        .receipt-divider ITENS DO PEDIDO
        .receipt-items
          template(v-if="isNormal")
            .receipt-item
              .receipt-item-row
                span.receipt-qty 2x
                span.receipt-item-name
                  strong LANCHE:&nbsp;
                  | X-BURGUER ESPECIAL
                span.receipt-item-price R$ 29,80
              .receipt-item-row.receipt-variation
                span -
                span
                  strong MOLHO:&nbsp;
                  | SEM MAIONESE
                span
            .receipt-item.receipt-item-sep
              .receipt-item-row
                span.receipt-qty 1x
                span.receipt-item-name
                  strong BEBIDA:&nbsp;
                  | SUCO DE LARANJA
                span.receipt-item-price R$ 8,00
              .receipt-item-row.receipt-obs
                span(colspan="3")
                  strong OBS.:&nbsp;
                  | SEM GELO
          template(v-else-if="isLimpo")
            .receipt-item
              .receipt-item-row
                span.receipt-qty 2x
                span.receipt-item-name
                  strong X-BURGUER ESPECIAL
                span.receipt-item-price R$ 14,90
              .receipt-item-row.receipt-variation
                span.receipt-qty 2x
                span.receipt-item-name
                  strong SEM MAIONESE
                span
            .receipt-item.receipt-item-sep
              .receipt-item-row
                span.receipt-qty 1x
                span.receipt-item-name
                  strong SUCO DE LARANJA
                span.receipt-item-price R$ 8,00
              .receipt-item-row.receipt-obs
                span
                  strong OBS.:&nbsp;
                  | SEM GELO
          template(v-else-if="isSimplificado")
            .receipt-item
              .receipt-item-row
                span.receipt-qty 2x
                span.receipt-item-name
                  strong X-BURGUER ESPECIAL
              .receipt-item-row.receipt-variation
                span.receipt-qty 2x
                span.receipt-item-name
                  strong SEM MAIONESE
            .receipt-item.receipt-item-sep
              .receipt-item-row
                span.receipt-qty 1x
                span.receipt-item-name
                  strong SUCO DE LARANJA
              .receipt-item-row.receipt-obs
                span
                  strong OBS.:&nbsp;
                  | SEM GELO
        template(v-if="!isSimplificado")
          .receipt-divider PAGAMENTO
          .receipt-payment-row
            span SUBTOTAL:
            span R$ 37,80
          .receipt-payment-row(v-if="isNormal")
            span TAXA DE ENTREGA:
            span R$ 5,00
          .receipt-payment-row.receipt-total
            span TOTAL:
            span R$ 42,80
          .receipt-payment-row
            span FORMA DE PAGAMENTO:
            span DINHEIRO
          .receipt-payment-row(v-if="isNormal")
            span PAGAMENTO:
            span R$ 50,00
          .receipt-payment-row(v-if="isNormal")
            span TROCO:
            span R$ 7,20
        .receipt-sep
        .receipt-center CUPOM NAO FISCAL
        .receipt-center(v-if="!$root.estabelecimentoSelecionado || !$root.estabelecimentoSelecionado.cardapio_digital") www.bigou.com.br
</template>

<script>
export default {
  name: 'PrintLayoutPreview',
  props: {
    layout: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    isNormal() { return this.layout === 1; },
    isLimpo() { return this.layout === 2; },
    isSimplificado() { return this.layout === 3; },
    layoutLabel() {
      return { 1: 'Normal', 2: 'Limpo', 3: 'Simplificado' }[this.layout] || 'Normal';
    },
  },
};
</script>

<style scoped>
.print-preview-wrapper {
  padding: 8px;
}

.print-preview-label {
  font-size: 10px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.print-preview-scroll {
  overflow-y: visible;
}

.print-receipt {
  font-family: Consolas, monospace;
  font-size: 11px;
  background: #fff;
  border: 1px dashed #ccc;
  padding: 8px 10px;
  width: 200px;
  margin: 0 auto;
  line-height: 1.5;
  color: #111;
}

.receipt-center {
  text-align: center;
}

.receipt-title {
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 2px;
}

.receipt-row {
  display: flex;
  flex-wrap: wrap;
  font-size: 10px;
  line-height: 1.4;
}

.receipt-label {
  font-weight: bold;
}

.receipt-bold {
  font-weight: bold;
}

.receipt-divider {
  text-align: center;
  font-weight: bold;
  font-size: 10px;
  border-top: 1px solid #111;
  border-bottom: 1px solid #111;
  margin: 4px 0;
  padding: 1px 0;
}

.receipt-items {
  margin: 2px 0;
}

.receipt-item {
  margin-bottom: 2px;
}

.receipt-item-sep {
  border-top: 1px solid #eee;
  padding-top: 2px;
}

.receipt-item-row {
  display: flex;
  align-items: flex-start;
  font-size: 10px;
  line-height: 1.4;
  gap: 2px;
}

.receipt-qty {
  min-width: 20px;
  flex-shrink: 0;
}

.receipt-item-name {
  flex: 1;
  word-break: break-word;
}

.receipt-item-price {
  white-space: nowrap;
  flex-shrink: 0;
  text-align: right;
  min-width: 44px;
}

.receipt-variation {
  padding-left: 4px;
  color: #444;
}

.receipt-obs {
  font-size: 10px;
  color: #444;
}

.receipt-payment-row {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  line-height: 1.5;
}

.receipt-total {
  font-weight: bold;
}

.receipt-sep {
  border-top: 1px solid #111;
  margin: 4px 0 2px;
}
</style>
